
import Vue from 'vue';

import { NormalizedMetadataField } from '@/types/apptypes';
import { BLDoc } from '@/types/blacklabtypes';

export type DocRowData = {
	type: 'doc';
	summary: string;
	href: string;
	doc: BLDoc,
};

export default Vue.extend({
	props: {
		data: Object as () => DocRowData,
		/** Optional! */
		metadata: Array as () => NormalizedMetadataField[]|undefined,
		colspan: Number as () => number|undefined,
	},

});
